import {useParentingResource} from 'app/pages/parenting/useParentingResource'
import {isParent} from 'common/HelperFunctions'
import {FC} from 'react'
import {Link} from 'react-router'
import {getProUpgrade} from 'setup/redux/Actions/SpMisc/spMisc'

import {useT} from '_metronic/i18n/t'

import type {ProUpgradeInfo} from './ProUpgradePage'

/**
 * The header user-menu entry "Upgrade to Pro" (legacy
 * views/front/new_layouts/header.php:517-526): shown to a parent without an
 * active subscription, in a school that has not made every module pro and
 * whose pro page is not hidden — the server decides (`showMenuLink`).
 * Renders nothing for everyone else.
 */
const UpgradeToProMenuItem: FC = () => {
  const t = useT()
  const parent = isParent()
  const {data} = useParentingResource<ProUpgradeInfo>(getProUpgrade, [], parent)

  if (!parent || !data?.showMenuLink || !data.available) return null

  return (
    <div className='menu-item px-5'>
      <Link to='/user/subscribe' className='menu-link px-5' data-testid='upgrade-to-pro-link'>
        <i className='fa fa-level-up-alt fs-6 me-3' aria-hidden='true' />
        <span className='menu-text'>{t('SP_MISC.PRO.TITLE')}</span>
      </Link>
    </div>
  )
}

export default UpgradeToProMenuItem
